import { render, staticRenderFns } from "./sendType.vue?vue&type=template&id=ee03f546&scoped=true&"
import script from "./sendType.vue?vue&type=script&lang=js&"
export * from "./sendType.vue?vue&type=script&lang=js&"
import style0 from "./sendType.vue?vue&type=style&index=0&id=ee03f546&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee03f546",
  null
  
)

export default component.exports